import * as React from 'react';
import moment from 'moment';
import { CTableRow, CTableDataCell } from '@coreui/react';

const AppendixRuleTableItem = ({ airline, flightNo, dep, arr, altn, era, aircraftType, registration, expiry, review, files, createAt, updateAt }) => {
  return <CTableRow>
    <CTableDataCell className={"RobotoMonoRg"}>{airline || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{flightNo || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{aircraftType || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{registration || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{dep || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{arr || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{altn || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{era || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{moment.utc(expiry).format("YYYY-MM-DD") || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg"}>{moment.utc(review).format("YYYY-MM-DD") || "-"}</CTableDataCell>
    <CTableDataCell className={"RobotoMonoRg formattedText"}>{(!!files && files?.length !== 0 && files.join(", ")) || "-"}</CTableDataCell>
  </CTableRow>
};

export default AppendixRuleTableItem;